import { render, staticRenderFns } from "./AlocarLotesCard.vue?vue&type=template&id=5ffce918&scoped=true&"
import script from "./AlocarLotesCard.vue?vue&type=script&lang=js&"
export * from "./AlocarLotesCard.vue?vue&type=script&lang=js&"
import style0 from "./AlocarLotesCard.vue?vue&type=style&index=0&id=5ffce918&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffce918",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VChip,VCol,VContainer,VIcon,VLayout,VRow,VTooltip})
